// extracted by mini-css-extract-plugin
export var buttons = "_11-0";
export var buttonsActive = "_11-h";
export var cancelConfirm = "_11-1";
export var closeButton = "_11-2";
export var column = "_11-3";
export var container = "_11-4";
export var detailHeader = "_11-6";
export var detailTitle = "_11-7";
export var detailsContent = "_11-5";
export var header = "_11-8";
export var headerWithClose = "_11-9";
export var icon = "_11-a";
export var infoIcon = "_11-c";
export var informationContainer = "_11-b";
export var sideDrawer = "_11-d";
export var sideDrawerOpen = "_11-e";
export var stickyFooter = "_11-f";
export var typeOption = "_11-g";